<!-- userData 用户数据 -->
<template>
  <div class="userData">
    <HeadCard></HeadCard>
    <p class="lineBg" />
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="每日统计报告" name="first"></el-tab-pane>
      <el-tab-pane label="用户行为明细" name="second"></el-tab-pane>
      <!-- <el-tab-pane label="活跃医生排名" name="third"></el-tab-pane>
      <el-tab-pane label="活跃员工排名" name="fourth"></el-tab-pane> -->
      <component :is="isComp"></component>
    </el-tabs>
  </div>
</template>

<script>
import StatisticsReport from './component/statisticsReport';
import BehaviorDetail from './component/behaviorDetail';
// import DoctorRank from './component/doctorRank';
// import StaffRank from './component/staffRank';
import HeadCard from './component/headCard';

const compMap = ['StatisticsReport', 'BehaviorDetail', 'DoctorRank', 'StaffRank'];

export default {
  name: 'UserData',
  components: {
    StatisticsReport,
    BehaviorDetail,
    // DoctorRank,
    // StaffRank,
    HeadCard,
  },
  props: {},
  data() {
    return {
      activeName: 'first',
      isComp: compMap[0],
    };
  },
  // 生命周期 - 创建完成（访问当前this实例）
  created() {},
  // 生命周期 - 挂载完成（访问DOM元素）
  mounted() {},
  methods: {
    handleClick(tab) {
      this.isComp = compMap[tab.index];
    },
  },
};
</script>
<style lang="scss" scoped>
.userData {
  .lineBg {
    width: 100%;
    height: 24px;
    background-color: rgba(0, 0, 0, 0.04);
  }
}
</style>
